import React from "react";
import { find, without } from "lodash";

import { uuid } from './utils';
import TextWithVariables from "./TextWithVariables";
import AdvancedActions from "./AdvancedActions";
import InactivityTimeoutConfig from "./InactivityTimeoutConfig";
import MessageOptionsSelect from './MessageOptionsSelect';
import ListOptionsMenuStep from "./ListOptionsMenuStep";
import FailedOption from "./FailedOption";

const MenuOption = ({
  chatbotOption,
  setChatbotOption,
  errors,
  customerColumns,
  chatbot
}) => {
  const updateInfo = (name, value) => {
    setChatbotOption({
      ...chatbotOption,
      [name]: value
    });
  };

  const maxCharacters = () => {
    if (chatbotOption.interactive !== 'text') return 20;
    return 400;
  };

  const addFailedOption = (currentOptions) => {
    const nodeId = uuid();

    return currentOptions.concat({
      id: null,
      text: 'Intentos fallidos',
      option_deleted: false,
      node_id: nodeId,
      source: chatbotOption.node_id,
      target: nodeId,
      parent_id: chatbotOption.id,
      fake_option: true,
      option_type: 'failure'
    });
  };

  const removeFailedOption = (currentOptions) => {
    let newArray = [...currentOptions];

    const failedOption = find(
      currentOptions,
      (option) => (option.option_type === 4 || option.option_type === 'failure') && option.option_deleted === false
    );

    if (failedOption?.id) {
      const optIndex = currentOptions.lastIndexOf(failedOption);
      newArray[optIndex].option_deleted = true;
    } else {
      newArray = without(currentOptions, failedOption);
    }

    return newArray;
  };

  return (
    <>
      <TextWithVariables
        chatbotOption={chatbotOption}
        setChatbotOption={setChatbotOption}
        errors={errors}
        customerColumns={customerColumns}
        maxChars={chatbot.max_button_size_text}
      />

      <div className="col-md-12 mt-20">
        <MessageOptionsSelect
          chatbotOption={chatbotOption}
          updateInfo={updateInfo}
          errors={errors}
          chatbot={chatbot}
        />
      </div>

      <ListOptionsMenuStep
        chatbotOption={chatbotOption}
        updateInfo={updateInfo}
        errors={errors}
      />

      <div className="mt-20">
        <FailedOption
          chatbotOption={chatbotOption}
          setChatbotOption={setChatbotOption}
          maxCharacters={maxCharacters}
          errors={errors}
          addFailedOption={addFailedOption}
          removeFailedOption={removeFailedOption}
        />
      </div>

      <div className="mt-20">
        <AdvancedActions
          chatbot={chatbot}
          chatbotOption={chatbotOption}
          setChatbotOption={setChatbotOption}
          customerColumns={customerColumns}
          errors={errors}
        />
      </div>

      <div className="mt-20">
        <InactivityTimeoutConfig
          chatbotOption={chatbotOption}
          setChatbotOption={setChatbotOption}
          errors={errors}
        />
      </div>
    </>
  );
};

export default MenuOption;
